import { CLEAR_RYFT_VERIFICATION_STATUS, GET_RYFT_VERIFICATION_STATUS } from "../../constants/userDocument/UserDocument"



const initialState = {
    isVerifiedRyft: null
}
export const GetRyftVerificationStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RYFT_VERIFICATION_STATUS:
            console.log("payment session",action.payload)
            return {
                ...state,
                isVerifiedRyft: action.payload,
            }
        case CLEAR_RYFT_VERIFICATION_STATUS:
            return {
               ...state,
               isVerifiedRyft: null,
            }
        default:
            return state
    }
}  